<div>
    <div class="mainDiv">
        <p style="margin: 0 0 10px; width: 400px;font-size: 16px;">Why are you deleting this market, please mention the reason below.</p>
        <form [formGroup]="marketrateform1">
            <textarea type="text" placeholder="Remark" required formControlName="Remark" maxlength="100" rows="3"
                style="width: 100%;"></textarea>
        </form>
        <div style="float: right;margin-top: 10px;margin-bottom: 13px;">
            <button mat-button (click)="submit()" style="margin-right: 5px;" class="btn btncls">Submit</button>
            <button mat-button class="btn btncls" (click)="onNoClick()">Cancel</button>
        </div>
    </div>
</div>